import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UIState {
  globalError: {
    message: string | null;
    visible: boolean;
  };
}

const initialState: UIState = {
  globalError: {
    message: null,
    visible: false,
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    showGlobalError(state, action: PayloadAction<string>) {
      state.globalError.message = action.payload;
      state.globalError.visible = true;
    },
    clearGlobalError(state) {
      state.globalError.message = null;
      state.globalError.visible = false;
    },
  },
});

export const { showGlobalError, clearGlobalError } = uiSlice.actions;
export default uiSlice.reducer;
